module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_9006.f3f0b523.png";